/** Локальный календарный YYYY-MM-DD (без сдвига UTC, как у toISOString). */
function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Первый и последний день предыдущего календарного месяца (локальное время). */
export function getPreviousFullMonthRange(): [string, string] {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const last = new Date(now.getFullYear(), now.getMonth(), 0);
  return [formatLocalYmd(first), formatLocalYmd(last)];
}
